import {TorchAPIConfiguration} from '../../../config/api.configuration';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Burly} from 'kb-burly';
import {TorchUser} from '../../@users/models/torch-user.model';
import {TorchUserService} from '../../@users/services/torch-user.service';
import {TorchAdminAPIKey} from '../models/torch-admin-api-key.model';
import {Injectable} from '@angular/core';

@Injectable()
export class TorchAPIKeysService {

  private currentUser: TorchUser;

  constructor(protected config: TorchAPIConfiguration, private httpClient: HttpClient, private torchUserService: TorchUserService) {
    this.torchUserService.currentTorchUser.subscribe(currentUser => this.currentUser = currentUser);
  }

  getAPITokens(): Observable<TorchAdminAPIKey[]> {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tokens')
      .addSegment('/list')
      .addQuery('emailAddress', this.currentUser.emailAddress)
      .addQuery('showAll', true)
      .get;

    return this.httpClient.get<TorchAdminAPIKey[]>(endpointURL);
  }

  createAPIToken(readOnly: boolean, rootKey: boolean, userEmail: string | null = null) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tokens')
      .addSegment('/create')
      .addQuery('emailAddress', (userEmail || this.currentUser.emailAddress))
      .addQuery('readOnly', readOnly)
      .addQuery('rootKey', rootKey)
      .get;

    return this.httpClient.post(endpointURL, {});
  }

  deleteToken(id: number) {
    const endpointURL = Burly(this.config.rootUrl)
      .addSegment('/tokens')
      .addSegment('/' + id)
      .addQuery('emailAddress', this.currentUser.emailAddress)
      .get;

    return this.httpClient.delete(endpointURL);
  }
}
